<div class="mb-3" [class.has-error]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>
  <div class="input-group" [nbSpinner]="loading" nbSpinnerStatus="basic">
    <div class="catalogMultiFormControl" (click)="openChooseCatalogModal()">
      <div>
        <div class="catalog-select-container">
          <div class="catalog-value-container">
            <div class="catalog-placeholder" *ngIf="catalogs.length === 0">{{props.placeholder}}</div>
            <div class="catalog-value" *ngFor="let catalog of catalogs">
              <span class="catalog-value-icon" (click)="removeCatalogValue(catalog)"><nb-icon icon="close-outline"></nb-icon></span>
              <span class="catalog-value-label">{{getOptionLabel(catalog)}}</span>
            </div>
          </div>

          <span class="catalog-values-clear" *ngIf="catalogs.length > 0" (click)="clearAllCatalogs()"><nb-icon icon="close-outline"></nb-icon></span>
        </div>
      </div>
    </div>

    <div class="input-group-append">
      <button nbButton [disabled]="loading" (click)="openChooseCatalogModal()">
        <nb-icon icon="list-outline"></nb-icon>
      </button>
    </div>
  </div>
  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
